module.exports = __webpack_public_path__ + "static/img/notice12.d07882b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice12.png
// module id = RXRp
// module chunks = 2